module.exports = __webpack_public_path__ + "img/4d.a9f34799.png";